import { ArtificialLiftTypeBase } from './base/artificial-lift-type-base';

export class ArtificialLiftType extends ArtificialLiftTypeBase { }